import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=1aed547b&scoped=true&"
import script from "./Completed.vue?vue&type=script&lang=js&"
export * from "./Completed.vue?vue&type=script&lang=js&"
import style0 from "./Completed.vue?vue&type=style&index=0&id=1aed547b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed547b",
  null
  
)

export default component.exports